import { TypographyVariant } from '@televet/kibble-ui/build/shared/types';
import { SemanticBackgroundColorToken } from '@televet/kibble-ui/build/theme/tokens';

export enum LocalRecapStatus {
  Ready = 'Ready',
  Recording = 'Recording',
  RecordingPaused = 'RecordingPaused',
  Processing = 'Processing',
  Uploading = 'Uploading',
  UploadingWithIssues = 'UploadingWithIssues',
  Done = 'Done',
  Error = 'Error',
}

export const RecapStatusToLabel: Record<LocalRecapStatus, string> = {
  [LocalRecapStatus.Ready]: 'Ready',
  [LocalRecapStatus.Recording]: 'Recording...',
  [LocalRecapStatus.RecordingPaused]: 'Paused',
  [LocalRecapStatus.Processing]: 'Uploading & Processing...',
  [LocalRecapStatus.Uploading]: 'Uploading & Processing...',
  [LocalRecapStatus.UploadingWithIssues]: 'Connection Issues - Retrying...',
  [LocalRecapStatus.Done]: 'Complete',
  [LocalRecapStatus.Error]: 'Upload Failed',
};

export const RecapStatusToBackgroundColor: Record<LocalRecapStatus, SemanticBackgroundColorToken> = {
  [LocalRecapStatus.Ready]: 'background.info',
  [LocalRecapStatus.Recording]: 'background.danger',
  [LocalRecapStatus.RecordingPaused]: 'background.lessSubtle',
  [LocalRecapStatus.Processing]: 'background.warning',
  [LocalRecapStatus.Uploading]: 'background.warning',
  [LocalRecapStatus.UploadingWithIssues]: 'background.warning',
  [LocalRecapStatus.Done]: 'background.success',
  [LocalRecapStatus.Error]: 'background.danger',
};

export const RecapStatusToTypographyVariant: Record<LocalRecapStatus, TypographyVariant> = {
  [LocalRecapStatus.Ready]: 'info',
  [LocalRecapStatus.Recording]: 'danger',
  [LocalRecapStatus.RecordingPaused]: 'default',
  [LocalRecapStatus.Processing]: 'warning',
  [LocalRecapStatus.Uploading]: 'warning',
  [LocalRecapStatus.UploadingWithIssues]: 'warning',
  [LocalRecapStatus.Done]: 'success',
  [LocalRecapStatus.Error]: 'danger',
};

export const RecapStatusDescription: Record<LocalRecapStatus, string> = {
  [LocalRecapStatus.Ready]:
    'After recording your appointment, AI Recap will automatically add a summary to your appointment notes.',
  [LocalRecapStatus.Recording]:
    'AI Recap will automatically add a summary to your appointment notes based on this recording.',
  [LocalRecapStatus.RecordingPaused]:
    'AI Recap will automatically add a summary to your appointment notes based on this recording.',
  [LocalRecapStatus.Processing]: 'Please allow a few minutes for the summary to appear in your appointment notes.',
  [LocalRecapStatus.Uploading]: 'Please allow a few minutes for the summary to appear in your appointment notes.',
  [LocalRecapStatus.UploadingWithIssues]:
    "Having trouble uploading due to connection issues. Please check your internet connection. We'll keep trying automatically.",
  [LocalRecapStatus.Done]: 'Please allow a few minutes for the summary to appear in your appointment notes.',
  [LocalRecapStatus.Error]:
    'Upload failed due to connection issues. Please check your internet connection and try again.',
};
